/**
 * Parse a date (or datetime) string as a local calendar date (no UTC day shift).
 */
export function parseLocalDateOnly(value) {
  if (value == null || value === '') return null;
  const dateStr =
    typeof value === 'string' ? value.slice(0, 10) : String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return null;
  const local = new Date(`${dateStr}T00:00:00`);
  return Number.isNaN(local.getTime()) ? null : local;
}

/** Whole calendar days from local today to the given date (can be negative). */
export function getCalendarDaysUntil(value) {
  const target = parseLocalDateOnly(value);
  if (!target) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (24 * 60 * 60 * 1000));
}

export function formatLocalDate(value, options = {}) {
  const local = parseLocalDateOnly(value);
  if (!local) return 'N/A';
  return local.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  });
}

/** YYYY-MM-DD for local calendar day. */
export function toLocalDateString(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate()
  ).padStart(2, '0')}`;
}
